/* tslint:disable */

/**
 */
export class TempPoint {
    value?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/temp-point.ts